import { onMounted, onUnmounted } from 'vue'
import { usePriceStore } from '@/stores/price'

export function usePricePolling(interval = 30000) {
  const priceStore = usePriceStore()
  let timer = null

  const startPolling = () => {
    stopPolling()
    timer = setInterval(() => {
      priceStore.loadPriceInfo()
    }, interval)
  }

  const stopPolling = () => {
    if (timer) {
      clearInterval(timer)
      timer = null
    }
  }

  onMounted(() => {
    startPolling()
  })

  onUnmounted(() => {
    stopPolling()
  })

  return {
    startPolling,
    stopPolling
  }
}